import { useMutation, UseMutationResult, useQueryClient } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { useApiClient } from '@/context/ApiClientContext/useApiClient.ts';
import { regenerate_automation_portal_link_url } from '@/utils/urls.ts';
import { AUTOMATION_PORTAL_KEY } from '@/utils/queryKeys.ts';
import { AutomationPortal } from '@/types/automations.ts';

type RegenerateAutomationPortalLinkParams = {
  automationId: string;
};

const useRegenerateAutomationPortalLink = (): UseMutationResult<
  AutomationPortal,
  AxiosError,
  RegenerateAutomationPortalLinkParams
> => {
  const apiClient = useApiClient();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ automationId }: RegenerateAutomationPortalLinkParams) => {
      const response = await apiClient.post(regenerate_automation_portal_link_url(automationId));
      return response.data;
    },
    onSuccess: async (portal: AutomationPortal) => {
      queryClient.setQueryData(AUTOMATION_PORTAL_KEY(portal.automation_id), portal);
    },
  });
};

export default useRegenerateAutomationPortalLink;
